import { IndustrialNav, IndustrialFooter, ScrollReveal, OperatorMandate } from "@/components/industrial";
import SEO from "@/components/SEO";
import HeroSection from "@/components/sections/HeroSection";
import DiagnosticSection from "@/components/sections/DiagnosticSection";
import FixableSection from "@/components/sections/FixableSection";
import MethodologySection from "@/components/sections/MethodologySection";
import EvidenceSection from "@/components/sections/EvidenceSection";
import OwnershipSection from "@/components/sections/OwnershipSection";
import GatekeeperSection from "@/components/sections/GatekeeperSection";
import SectionProgressBar from "@/components/sections/SectionProgressBar";

const Index = () => (
  <div className="min-h-screen">
    <SEO
      title="Great Business, Broken Website — William Palmer"
      description="Great business, broken website? Structural web architecture that turns your site into an operational tool."
    />
    <IndustrialNav />
    <SectionProgressBar />

    <main id="main-content">
      <div id="hero"><HeroSection /></div>
      <ScrollReveal><div id="diagnostic"><DiagnosticSection /></div></ScrollReveal>
      <ScrollReveal><div id="fixable"><FixableSection /></div></ScrollReveal>
      <ScrollReveal><div id="methodology"><MethodologySection /></div></ScrollReveal>
      <ScrollReveal><div id="evidence"><EvidenceSection /></div></ScrollReveal>
      <ScrollReveal><div id="ownership"><OwnershipSection /></div></ScrollReveal>
      <ScrollReveal><div id="gatekeeper"><GatekeeperSection /></div></ScrollReveal>
      <ScrollReveal><div id="mandate"><OperatorMandate /></div></ScrollReveal>
    </main>

    <IndustrialFooter />
  </div>
);

export default Index;
